import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

class AppGroupService {
    async getAppGroups(environmentName?: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/AppGroup`;
        if (environmentName) url += `?environmentName=${encodeURIComponent(environmentName)}`;
        let response = await getAuthenticatedFetch()(url);
        return await response.json();
    }

    async getSqlServerVersion(serverId: number, environmentName?: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/AppGroup/${serverId}/sqlversion`;
        if (environmentName) url += `?environmentName=${encodeURIComponent(environmentName)}`;
        let response = await getAuthenticatedFetch()(url);
        return response.text();
    }

    async getCachedServiceHealthListByAppGroupName(appGrp: string, environmentName?: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/appGroup/${appGrp}/servicehealth`;
        if (environmentName) url += `?environmentName=${encodeURIComponent(environmentName)}`;
        let response = await getAuthenticatedFetch()(url);
        
        if (!response.ok) {
            throw new Error();
        }
        
        return await response.json();
    }

    async octopusSyncForAll(environmentName?: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/appGroup/octopusSync`;
        if (environmentName) url += `?environmentName=${encodeURIComponent(environmentName)}`;
        let response = await getAuthenticatedFetch()(url, {
            method: 'POST'
        });

        if (!response.ok) {
            throw new Error();
        }

        return await response.json();
    }
    
    async octopusSyncForAppGroup(appGrp: string, environmentName?: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/appGroup/${appGrp}/octopusSync`;
        if (environmentName) url += `?environmentName=${encodeURIComponent(environmentName)}`;
        let response = await getAuthenticatedFetch()(url, {
            method: 'POST'
        });

        if (!response.ok) {
            throw new Error();
        }
        
        const jsonResponse = await response.json();

        if (!jsonResponse.success) {
            throw new Error();
        }
        
        return jsonResponse;
    }
}

export default new AppGroupService();
